import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoRecursoConcedidoService from '../../servicos/EmpenhosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEmpenhoRecursoConcedidoInicio: [],
    buscaEmpenhoRecursoConcedidoSucesso: ['empenhoRecursoConcedido'],
    buscaEmpenhoRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEmpenhoRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEmpenhoRecursoConcedidoInicio())
        let serv = new DetalhesEmpenhoRecursoConcedidoService()
        return serv
            .consultarEmpenhoRecursoConcedido(filtro)
            .then(response => dispatch(Creators.buscaEmpenhoRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEmpenhoRecursoConcedidoErro(error)))
    }
}

const buscaEmpenhoRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaEmpenhoRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaEmpenhoRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.empenhoRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EMPENHO_RECURSO_CONCEDIDO_INICIO]: buscaEmpenhoRecursoConcedidoInicio,
    [Types.BUSCA_EMPENHO_RECURSO_CONCEDIDO_ERRO]: buscaEmpenhoRecursoConcedidoErro,
    [Types.BUSCA_EMPENHO_RECURSO_CONCEDIDO_SUCESSO]: buscaEmpenhoRecursoConcedidoSucesso,
})
